import React from 'react';
import MaskedInput from 'react-text-mask';

const phoneMask = [/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
const PhoneInput = React.forwardRef(({ ...props }, ref) => (
  <MaskedInput {...props} ref={ref} mask={phoneMask} placeholderChar={'\u2000'} />
));
export default PhoneInput;
